const donationProjectNodes = document.querySelectorAll('.donation-project');
const cartDonationNode = document.querySelector('.cart-donation-project');
let pendingDonationRequest = null;

if (cartDonationNode || (donationProjectNodes && donationProjectNodes.length)) {
  initDonationProjects();
}

function startAnimation(entry, donationAmountAutomation) {
  const countSpeed = entry.target.getAttribute('data-count-speed') ? entry.target.getAttribute('data-count-speed') : 50;
  const amountCountedInHundreds = entry.target.getAttribute('data-count-in-hundreds') ? entry.target.getAttribute('data-count-in-houndred') : 5000;
  const amountCountedInOnes = entry.target.getAttribute('data-count-in-ones') ? entry.target.getAttribute('data-count-in-houndred') : 0;
  const goalAmount = entry.target.getAttribute('data-goal-amount') || 0;
  const donationValue = Math.floor(Number(donationAmountAutomation.donationValue)) || 0;
  const currentAmountMetafield = Number(entry.target.getAttribute('data-amount')) || 0;
  const sourceOfCurrentAmount = entry.target.getAttribute('data-source-of-current-amount');
  const target = sourceOfCurrentAmount === 'current_amount' ? currentAmountMetafield : sourceOfCurrentAmount === 'api_automation' ? donationValue : 0;
  let progress = goalAmount > 0
    ? target * 100 / goalAmount
    : 0;

  if (progress > 100) progress = 100;

  entry.target.style.cssText = `--progress: ${progress}%`;
  entry.target.querySelector('.donation-project__progress-bar').style.animationPlayState = 'running';
  countUp(entry.target, countSpeed, amountCountedInHundreds, amountCountedInOnes, target);
}

function countUp(project, speed, amountCountedInHundreds, amountCountedInOnes, target) {
  const targetPlacement = project.querySelector('.current-amount');
  const targetPlacementCopy = project.querySelector('.donation-project__progress-bar .current-amount');

  // Calculate breakpoints
  const thousandsLimit = Math.floor(target / 1000) * 1000;
  const hundredsLimit = Math.floor(target / 100) * 100;
  let count = 0;

  const thousandsInterval = setInterval(() => {
    if (count == target) {
      const onesInterval = setInterval(() => {
        if (count >= target) {
          clearInterval(onesInterval);
        } else {
          count += 1;
          targetPlacement.textContent = count.toLocaleString();
          targetPlacementCopy.textContent = count.toLocaleString();
        }
      }, speed);

      clearInterval(onesInterval);
    } else if (count >= thousandsLimit) {
      clearInterval(thousandsInterval);
      countByHundreds();
    } else {
      count += 1000;
      targetPlacement.textContent = count.toLocaleString();
      targetPlacementCopy.textContent = count.toLocaleString();
    }
  }, speed);

  function countByHundreds() {
    const hundredsInterval = setInterval(() => {
      if (count == target) {
        const onesInterval = setInterval(() => {
          if (count >= target) {
            clearInterval(onesInterval);
          } else {
            count += 1;
            targetPlacement.textContent = count.toLocaleString();
            targetPlacementCopy.textContent = count.toLocaleString();
          }
        }, speed);

        clearInterval(onesInterval);
      } else if (count >= hundredsLimit) {
        clearInterval(hundredsInterval);
        countByOnes();
      } else {
        count += 100;
        targetPlacement.textContent = count.toLocaleString();
        targetPlacementCopy.textContent = count.toLocaleString();
      }
    }, speed);
  }

  function countByOnes() {
    const onesInterval = setInterval(() => {
      if (count >= target) {
        clearInterval(onesInterval);
      } else {
        count += 1;
        targetPlacement.textContent = count.toLocaleString();
        targetPlacementCopy.textContent = count.toLocaleString();
      }
    }, speed);
  }
}

function updateCartDonation(cartDonationNode, donationAmountAutomation) {
  if (!cartDonationNode) {
    console.error('Cart donation node not found');
    return;
  }

  const donationValue = donationAmountAutomation
    ? Math.floor(Number(donationAmountAutomation.donationValue)) || 0
    : 0;
  const goalAmount = Number(cartDonationNode.getAttribute('data-goal-amount')) || 0;
  const currentAmountMetafield = Number(cartDonationNode.getAttribute('data-current-amount-metafield')) || 0;
  const sourceOfCurrentAmount = cartDonationNode.getAttribute('data-source-of-current-amount-cart-drawer');
  const progressVerb = cartDonationNode.getAttribute('data-progress-verb');

  const current = sourceOfCurrentAmount === 'current_amount'
    ? currentAmountMetafield
    : sourceOfCurrentAmount === 'api_automation'
      ? donationValue
      : 0;
  const progressRealPercentage = goalAmount > 0
    ? Math.floor(current * 100 / goalAmount)
    : 0;
  const progress = progressRealPercentage > 100 ? 100 : progressRealPercentage;
  const progressBar = cartDonationNode.querySelector('.progressbar span');

  if (progressBar) progressBar.style.cssText = `--progress: ${progress}%`;

  const progressPercentageNumberNode = cartDonationNode.querySelector('.progress-block__progress-line p');
  if (progressPercentageNumberNode && progressVerb) {
    progressPercentageNumberNode.textContent = `${progressRealPercentage}% ${progressVerb}`;
  }
}

async function getDonationAmountAutomation() {
  const CACHE_KEY = 'donationAmountAutomation';
  const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes in milliseconds

  if (pendingDonationRequest) {
    return pendingDonationRequest;
  }

  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      const now = Date.now();

      // If cache is still valid return it immediately
      if (now - timestamp < CACHE_DURATION) {
        return data;
      } else {
        console.log('donation amount automation cache expired');
      }
    }
  } catch (e) {
    console.log('cache read failed, fetching from API');
  }


  const devApi = ''; // replace with your local server url
  const productionApi = 'https://netlify.blacklemon.dk/.netlify';
  const functionName = '/functions/getOrganicBasicsDonationAmount';
  const api = devApi != '' && Shopify.theme.role === 'development' ? devApi : productionApi;
  const url = `${api}${functionName}`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    }
  }

  // Set pending request to avoid multiple requests
  pendingDonationRequest = fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        data: data,
        timestamp: Date.now()
      }));

      // Clear the pending request
      pendingDonationRequest = null;
      return data;
    })
    .catch(error => {
      // Clear the pending request on error so it can retry
      pendingDonationRequest = null;
      throw error;
    });

  return pendingDonationRequest;
}

async function initDonationProjects() {
  const donationProjectNodes = document.querySelectorAll('.donation-project');
  const cartDonationNode = document.querySelector('.cart-donation-project');

  if ((!donationProjectNodes || !donationProjectNodes.length) && !cartDonationNode) {
    return;
  }


  const donationObserverCallback = async (entries, observer) => {
    const visibleEntries = entries.filter(entry => {
      if (!entry.isIntersecting) return false;

      const isDonationProject = entry.target.classList.contains('donation-project');
      const isCartDonationProject = entry.target.classList.contains('cart-donation-project');

      return isDonationProject || isCartDonationProject;
    });

    if (!visibleEntries.length) return;
    const donationAmountAutomation = await getDonationAmountAutomation();

    visibleEntries.forEach(entry => {
      if (entry.target.classList.contains('donation-project')) {
        startAnimation(entry, donationAmountAutomation);
      } else if (entry.target.classList.contains('cart-donation-project')) {
        updateCartDonation(entry.target, donationAmountAutomation);
      }

      observer.unobserve(entry.target);
    });
  };
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 1      // Trigger when all of the element is visible
  };
  const donationObserver = new IntersectionObserver(donationObserverCallback, options);

  if (donationProjectNodes && donationProjectNodes.length) {
    donationProjectNodes.forEach(element => {
      donationObserver.observe(element);
    });
  }

  if (cartDonationNode) {
    donationObserver.observe(cartDonationNode);
  }
}